import { Button } from '@clearcover/atlas';
import classnames from 'classnames';
import React, { FC } from 'react';
import styles from './styles.module.css';

type ConfirmationModalProps = {
  onSubmit: () => void;
  close: () => void;
  isSubmitting: boolean;
  disabled?: boolean;
  error?: string;
  headerText: string;
  bodyText: string;
  backText?: string;
  confirmText?: string;
  variant?: 'danger' | 'primary';
};

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  close,
  onSubmit,
  isSubmitting,
  error,
  headerText,
  bodyText,
  disabled,
  backText = 'Go Back',
  confirmText = 'Confirm',
  variant = 'danger',
}) => {
  return (
    <div
      data-testid="confirmation-modal-container"
      className={classnames('fs-mask', styles.confirmModalContainer)}
      onClick={(event) => event.stopPropagation()}
    >
      <h1 className={styles.heading}>{headerText}</h1>
      <p className={styles.message}>{bodyText}</p>
      <div className={styles.buttonContainer}>
        <Button
          block
          data-testid="go-back-button"
          variant="secondary"
          size={'md'}
          onClick={close}
        >
          {backText}
        </Button>
        <Button
          block
          data-testid="confirm-button"
          variant={variant}
          size={'md'}
          isSubmitting={isSubmitting}
          onClick={onSubmit}
          disabled={disabled}
        >
          {confirmText}
        </Button>
      </div>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};
